import { cloneElement, useCallback } from 'react';
import PropTypes from 'prop-types';
import DialogContent from '@mui/material/DialogContent';

import { getLabelMessage } from '@gef-ui/localization/messages';
import { useLocalConfirmDialog } from '@gef-ui/material/components/Dialog/ConfirmDialog';
import GenericDialog from '@gef-ui/material/components/Dialog/GenericDialog';

import { modalsWithCheckBeforeClosingLightbox } from 'constants/modals';

// fix borderColor for tables in darkMode
const tablesInsideModals = {
	'& tbody': {
		'.MuiTableCell-root': {
			borderColor: 'background.300',
		},
	},
};

const Dialog = ({
	modal,
	version,
	withCross = true,
	fullWidth = true,
	maxWidth = 'md',
	onExit,
	title,
	versionDialogContentProps,
	...other
}) => {
	const [confirmDialog, open] = useLocalConfirmDialog({
		backdropClose: false,
		title: getLabelMessage('confirm:doYouWantToLeave'),
		content: getLabelMessage('confirm:changesWontBeSaved'),
		onOk: () => {
			!!onExit && onExit(modal.id);
			modal.hide();
		},
	});

	const handleExit = useCallback(() => {
		if (modalsWithCheckBeforeClosingLightbox.includes(modal.id)) {
			open();
		} else {
			!!onExit && onExit(modal.id);
			modal.hide();
		}
	}, [onExit, modal, open]);

	return (
		<>
			{confirmDialog}
			<GenericDialog
				open={modal.visible}
				title={title}
				footer={
					!!version && (
						<DialogContent {...versionDialogContentProps}>
							{cloneElement(version, { sx: { mt: 0 } })}
						</DialogContent>
					)
				}
				withCross={withCross}
				onExit={handleExit}
				fullWidth={fullWidth}
				maxWidth={maxWidth}
				DialogTitleProps={{ align: 'left', sx: [!!title && { mb: 1, fontSize: 20 }] }}
				DialogActionsProps={{ sx: { justifyContent: 'center', pb: 6 } }}
				DialogContentProps={{ sx: { px: 6, pb: 5, ...tablesInsideModals } }}
				{...other}
			/>
		</>
	);
};

Dialog.propTypes = {
	fullWidth: PropTypes.bool,
	maxWidth: PropTypes.string,
	modal: PropTypes.object,
	onExit: PropTypes.func,
	title: PropTypes.node,
	version: PropTypes.any,
	versionDialogContentProps: PropTypes.object,
	withCross: PropTypes.bool,
};

export default Dialog;
